import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ReglesCommunaute() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar onCreateClick={() => { }} createLabel="Publier" />

      <section className="relative w-full overflow-hidden bg-primary-500">
        <div className="px-4 md:px-8 py-[1.5rem] md:py-10">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/20 text-white text-sm font-medium">
              <i className="ri-shield-star-line"></i>
              Règles de la communauté
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-[2rem] font-semibold text-white leading-tight">
              Un espace local, convivial et respectueux
            </h1>

            <p className="mt-4 text-lg md:text-[1rem] text-white/90 max-w-2xl mx-auto leading-relaxed">
              En participant à Yonyon, tu t'engages à respecter ces règles
              afin que chacun puisse échanger, sortir, bouger et s'entraider
              dans de bonnes conditions.
            </p>
          </div>
        </div>
      </section>

      <main className="flex-1 w-full px-4 md:px-8 py-10 md:py-14">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white border border-background-200 rounded-lg p-6 md:p-10 text-sm">

            <p className="text-foreground-500 mb-8">
              Dernière mise à jour : septembre 2026
            </p>

            {/* 1 */}
            <h2 className="font-heading text-xl font-semibold text-foreground-950">
              1. Respect et bienveillance
            </h2>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Chaque membre doit pouvoir utiliser Yonyon dans un climat
              respectueux. Les désaccords sont autorisés, mais les insultes,
              menaces, intimidations, humiliations, comportements
              discriminatoires, propos haineux et formes de harcèlement
              ne sont pas acceptés.
            </p>

            {/* 2 */}
            <h2 className="mt-8 font-heading text-xl font-semibold text-foreground-950">
              2. Âge minimum
            </h2>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Yonyon est réservé aux personnes âgées de 18 ans ou plus.
              Lors de la création d'un compte, chaque membre confirme
              respecter cette condition.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Évite de publier des informations permettant de te localiser
              personnellement avec précision, comme ton adresse personnelle
              ou tes habitudes de déplacement.
            </p>

            {/* 3 */}
            <h2 className="mt-8 font-heading text-xl font-semibold text-foreground-950">
              3. Contenus interdits
            </h2>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Les publications, activités et commentaires ne doivent pas
              contenir de contenu illégal, sexuel explicite, particulièrement
              violent ou destiné à choquer, ni encourager des comportements
              dangereux ou illégaux.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Sont également interdits les arnaques, le spam, les tentatives
              d'usurpation d'identité, les accusations publiques nominatives
              susceptibles de porter atteinte à une personne, ainsi que la
              publication d'informations personnelles concernant quelqu'un
              sans son accord.
            </p>

            {/* 4 */}
            <h2 className="mt-8 font-heading text-xl font-semibold text-foreground-950">
              4. Des publications utiles à la communauté
            </h2>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Yonyon permet de partager des activités, événements, initiatives
              locales, demandes ou propositions d'entraide, questions et
              informations utiles autour de chez soi.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Les particuliers, associations et acteurs locaux sont les
              bienvenus lorsqu'ils partagent un contenu pertinent pour la
              communauté. Le spam, les publications répétitives et le
              démarchage abusif ne sont en revanche pas autorisés.
            </p>

            {/* 5 */}
            <h2 className="mt-8 font-heading text-xl font-semibold text-foreground-950">
              5. Activités et rencontres
            </h2>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Si tu proposes une activité, donne des informations aussi
              claires que possible sur son objet, son lieu, son horaire et
              ses éventuelles conditions de participation.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Ne publie pas volontairement une fausse activité et ne cherche
              pas à tromper les autres participants. En cas d'empêchement ou
              d'annulation, préviens les participants lorsque les
              fonctionnalités de Yonyon te permettent de le faire.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Les activités publiées sur Yonyon sont proposées et organisées
              par leurs auteurs, sous leur responsabilité. Yonyon met à
              disposition une application permettant aux membres de publier,
              découvrir et rejoindre des activités, mais n'organise pas
              lui-même ces activités et n'en assure pas l'encadrement.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              L'auteur d'une activité est responsable des informations qu'il
              publie et de l'organisation de l'activité qu'il propose. Chaque
              membre reste libre de participer ou non à une activité et doit
              prendre les précautions adaptées à la situation.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Yonyon ne garantit notamment pas l'identité, le comportement,
              les compétences ou les déclarations des membres, ni le
              déroulement d'une activité organisée par un utilisateur.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Ces dispositions n'excluent pas les responsabilités qui
              pourraient incomber à Yonyon en application de la loi.
            </p>

            {/* 6 */}
            <h2 className="mt-8 font-heading text-xl font-semibold text-foreground-950">
              6. Vie privée et sécurité
            </h2>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Ne publie pas publiquement ton adresse personnelle exacte,
              tes informations bancaires, tes mots de passe ou toute autre
              information sensible.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Ne publie pas non plus le numéro de téléphone, l'adresse,
              des documents personnels ou d'autres informations privées
              appartenant à une autre personne sans son accord.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Lorsqu'une publication concerne une rencontre ou une activité,
              privilégie les informations nécessaires à l'organisation sans
              révéler inutilement des informations personnelles.
            </p>

            {/* 7 */}
            <h2 className="mt-8 font-heading text-xl font-semibold text-foreground-950">
              7. Photos et respect des personnes
            </h2>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Ne publie pas une photo ou une information concernant une autre
              personne dans le but de l'identifier, de l'exposer, de la
              rechercher ou de lui nuire de manière inappropriée.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Respecte la vie privée et le droit à l'image des personnes
              présentes sur les contenus que tu publies.
            </p>

            {/* 8 */}
            <h2 className="mt-8 font-heading text-xl font-semibold text-foreground-950">
              8. Le Coin
            </h2>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Le Coin est destiné aux discussions, questions, conseils et
              échanges locaux. Le fait qu'une publication puisse ne pas
              afficher publiquement l'identité de son auteur ne signifie pas
              que tout est permis.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Les mêmes règles de respect, de sécurité et de légalité
              s'appliquent dans Le Coin. Les insultes, menaces, harcèlement,
              accusations nominatives, divulgations d'informations privées
              et contenus interdits peuvent être modérés.
            </p>

            {/* 9 */}
            <h2 className="mt-8 font-heading text-xl font-semibold text-foreground-950">
              9. Signalements
            </h2>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Si tu constates une publication ou un comportement contraire
              à ces règles, tu peux utiliser la fonction de signalement.
              Les signalements permettent à la modération d'examiner les
              contenus concernés.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              L'utilisation abusive ou répétée du système de signalement
              dans le but de nuire à un autre membre peut également faire
              l'objet de mesures de modération.
            </p>

            {/* 10 */}
            <h2 className="mt-8 font-heading text-xl font-semibold text-foreground-950">
              10. Modération et sanctions
            </h2>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Les publications sont généralement mises en ligne directement
              par leurs auteurs et ne font pas nécessairement l'objet d'une
              validation préalable.
            </p>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              En cas de non-respect de ces règles, Yonyon peut notamment
              retirer un contenu, limiter certaines fonctionnalités,
              suspendre temporairement un compte ou bannir un membre.
              La mesure appliquée dépend notamment de la nature, de la
              gravité et de la répétition des faits constatés.
            </p>

            {/* 11 */}
            <h2 className="mt-8 font-heading text-xl font-semibold text-foreground-950">
              11. Évolution des règles
            </h2>

            <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
              Ces règles peuvent évoluer avec Yonyon, notamment lorsque de
              nouvelles fonctionnalités ou de nouveaux services sont
              proposés. La date de dernière mise à jour est indiquée en haut
              de cette page.
            </p>

            <div className="my-10 border-t border-background-200" />

            {/* Conditions d'utilisation */}
            <section id="conditions-utilisation">
              <h2 className="font-heading text-2xl font-semibold text-foreground-950">
                Conditions d'utilisation
              </h2>

              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                Utilisation du service
              </h3>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Yonyon est une application locale permettant notamment de
                découvrir et proposer des activités, publier et consulter des
                contenus locaux, échanger avec d'autres membres et proposer ou
                demander de l'entraide.
              </p>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Chaque membre est responsable des contenus qu'il publie et de
                l'utilisation qu'il fait du service. Il est interdit d'utiliser
                Yonyon dans un but frauduleux, illégal, nuisible ou contraire
                aux présentes règles.
              </p>

              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                Disponibilité du service
              </h3>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Yonyon peut être temporairement indisponible, notamment en
                raison d'une opération de maintenance, d'une mise à jour ou
                d'un incident technique. Yonyon ne garantit pas un
                fonctionnement permanent et sans interruption du service.
              </p>

              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                Compte utilisateur
              </h3>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Chaque membre est responsable de la confidentialité de ses
                identifiants et de l'utilisation de son compte. En cas de
                non-respect des présentes règles, Yonyon peut prendre les
                mesures de modération prévues ci-dessus.
              </p>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                L'utilisation de Yonyon implique l'acceptation des présentes
                règles et conditions d'utilisation.
              </p>
            </section>

            <div className="my-10 border-t border-background-200" />

            {/* Informations légales */}
            <section id="mentions-legales">
              <h2 className="font-heading text-2xl font-semibold text-foreground-950">
                Informations légales
              </h2>

              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                Édition du site
              </h3>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Yonyon est un service en ligne édité à titre personnel et non
                professionnel.
              </p>

              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                Hébergement
              </h3>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Le site Yonyon est hébergé par :
                <br />
                <strong>IONOS SARL</strong>
                <br />
                7 place de la Gare
                <br />
                57200 Sarreguemines
                <br />
                France
              </p>

              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                Contact
              </h3>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Pour toute question concernant Yonyon, tu peux utiliser la page{' '}
                <Link to="/contact" className="underline font-medium">
                  Contact
                </Link>.
              </p>

            </section>

            <div className="my-10 border-t border-background-200" />

            {/* Confidentialité et données personnelles */}
            <section id="confidentialite">
              <h2 className="font-heading text-2xl font-semibold text-foreground-950">
                Confidentialité et données personnelles
              </h2>

              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                Données utilisées par Yonyon
              </h3>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Pour assurer le fonctionnement de la application, Yonyon peut
                traiter les informations fournies lors de la création et de
                l'utilisation d'un compte ainsi que les contenus et
                informations nécessaires au fonctionnement des différentes
                fonctionnalités du service.
              </p>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Cela peut notamment concerner les informations du profil, les
                publications, activités, commentaires, réactions,
                participations, signalements et autres interactions effectuées
                sur la application.
              </p>

              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                Localisation
              </h3>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Yonyon utilise des informations de localisation pour permettre
                notamment de proposer des activités et publications situées
                autour d'une zone géographique. La position personnelle précise
                d'un utilisateur n'est pas destinée à être affichée
                publiquement aux autres membres.
              </p>

              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                Finalités
              </h3>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Ces données sont utilisées notamment pour permettre le
                fonctionnement des comptes, fournir les fonctionnalités de
                Yonyon, afficher les contenus pertinents à proximité, assurer
                la sécurité et la modération de l'application et répondre aux
                demandes envoyées via le formulaire de contact.
              </p>

              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                Partage des données
              </h3>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Yonyon ne revend pas les données personnelles de ses
                utilisateurs. Certaines données peuvent toutefois être
                traitées par les prestataires techniques nécessaires au
                fonctionnement du service, notamment pour l'hébergement et les
                services techniques utilisés par l'application.
              </p>

              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                Conservation
              </h3>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Les données sont conservées pendant une durée adaptée à leur
                finalité et au fonctionnement du service, sous réserve des
                obligations légales qui pourraient imposer une durée
                différente.
              </p>

              <h3 className="mt-6 font-heading text-lg font-semibold text-foreground-950">
                Tes droits
              </h3>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Conformément à la réglementation applicable en matière de
                protection des données personnelles, tu peux notamment
                demander, selon les conditions prévues par la réglementation,
                l'accès à tes données, leur rectification ou leur suppression,
                ainsi que l'exercice des autres droits dont tu disposes.
              </p>

              <p className="mt-2 text-foreground-700 max-w-[640px]: font-medium leading-relaxed">
                Pour exercer tes droits ou poser une question concernant tes
                données personnelles, utilise la page{' '}
                <Link to="/contact" className="underline font-medium">
                  Contact
                </Link>.
              </p>
            </section>

            <div className="mt-10 p-4 rounded-lg bg-primary-50 border border-primary-100 flex items-start gap-3">
              <i className="ri-information-line text-primary-600 text-xl mt-0.5"></i>

              <p className="text-primary-800">
                En créant un compte et en utilisant Yonyon, tu confirmes avoir
                18 ans ou plus et tu t'engages à respecter les présentes règles
                et conditions d'utilisation. Pour toute question concernant
                Yonyon, les présentes règles ou tes données personnelles,
                utilise la page{' '}
                <Link
                  to="/contact"
                  className="underline font-medium cursor-pointer"
                >
                  Contact
                </Link>.
              </p>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4">
              <Link
                to="/"
                className="px-5 py-2.5 rounded-md bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-compass-3-line"></i>
                Retour à l'accueil
              </Link>

              <Link
                to="/contact"
                className="px-5 py-2.5 rounded-md border border-background-300 text-sm font-semibold text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-mail-line"></i>
                Nous écrire
              </Link>
            </div>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}